module.exports = __webpack_public_path__ + "static/media/BM.d1c8883d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/BM.svg
// module id = 2115
// module chunks = 7